import type { AppointmentsFeatureConfig } from './type';

export const appointments: Partial<AppointmentsFeatureConfig> = {
    fetchHomeBranchById: true,
    invalidateCacheAfterCancelingAppointment: true,
    timeslotsIntervalInDays: 14,
    videoAppointmentInNewTab: false,
};
